import { createApp, defineComponent } from 'vue';
import GridProgressCellEditor from './GridProgressCellEditor.vue';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridProgressCellEditor);

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder);
      vueInstance = vueApp.mount(placeholder);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;
    },

    set_value(task, id, column, node) {
      vueInstance.value = Math.floor(task.progress * 100);
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      return true;
    },

    is_valid(value, id, column, node) {
      return +value >= 0 && +value <= 100;
    },

    save(id, column, node) {
      const task = instance.getTask(id);

      task.progress = Math.round(vueInstance.value) / 100;
      instance.updateTask(task.id);

      userExtAnalytics.log('task_grid_action', { action: 'progress' });
    },

    focus(node) {
    },
  };
}
